import React, { useState, useEffect, createRef } from 'react';
import clsx from 'clsx';
import './style.scss';
import { IPanelBodyProps } from './panel-body';

export interface IPanelProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    collapsible?: boolean;
    width?: number;
    onChange?: (e) => void
}

export const Panel: React.FC<IPanelProps> = React.forwardRef((props, ref): JSX.Element => {
    const {
        className,
        onChange,
        ...rest
    } = props;

    return (
        <div
            className={clsx('oms-panel', className)}
            ref={ref}
            {...rest}
        />
    );
});
